import React from 'react';
import Select from 'react-select';
import { preventDefaults } from 'survey-creator-react';

const CustomSelect = (props) => {
    const handleMenuOpen = (event) => {
        event.stopPropagation();
        preventDefaults(event);
    };

    // Varsay�lan portal hedefi ve z-index y�ksekli�i ekleyin
    const portalTarget = props.menuPortalTarget ?? document.body;
    const portalStyles = {
        menuPortal: base => ({
            ...base,
            zIndex: 9999
        }),
        ...(props.styles || {})
    };

    return (
        <Select
            {...props}
            menuPortalTarget={portalTarget}
            styles={portalStyles}
            menuPosition="fixed"
            onMouseDown={(event) => {
                handleMenuOpen(event);
                props.onMenuOpen?.(event);
            }}
        />
    );
};

export default CustomSelect;
